import { useEffect, useState } from "react";
import * as cookie from "cookie";
import { useAppContext } from "../../hooks";
import LanguageContext from "./LanguageContext";
import { Language } from "../../tools";

const NavigatorLngMap = {
  cscz: "cs",
  // TODO: Commented to force only cs language
  // engb: "en",
  // enus: "en",
};

const DEFAULT_LNG = Language.getDefault();
const LNG_COOKIE = "userlng";
const COOKIE_AGE = 2147483647;

function getCookieLanguage() {
  const cookies = cookie.parse(document.cookie);
  return cookies[LNG_COOKIE];
}

function getBrowserLanguage() {
  let navigatorLng = navigator.language || navigator.userLanguage;
  navigatorLng = navigatorLng.replace(/-/g, "").toLowerCase();
  return NavigatorLngMap[navigatorLng] || DEFAULT_LNG;
}

function LanguageContextProvider({ children }) {
  const [language, setLanguage] = useState(() => getCookieLanguage() || getBrowserLanguage());

  // automatically read language from backend
  const appContext = useAppContext();
  useEffect(() => {
    if (appContext?.data?.user?.language) {
      updateLanguage(appContext.data.user.language);
    }
  }, [appContext?.data?.user?.language]);

  // save chosen lng to cookie for refreshes
  function updateLanguage(language) {
    document.cookie = cookie.serialize(LNG_COOKIE, language, {
      maxAge: COOKIE_AGE,
      sameSite: "strict",
      path: "/neverLeaveClient",
    });
    setLanguage(language);
  }

  const contextValue = {
    language,
    setLanguage: updateLanguage,
  };

  return (
    <LanguageContext.Provider value={contextValue}>
      {typeof children === "function" ? children(contextValue) : children}
    </LanguageContext.Provider>
  );
}

export default LanguageContextProvider;
